export const navigateToUrlIfPresent = url => {
  if (url && __CLIENT__) {
    window.routerHistory.push(url);
  }
};
